import { useActiveWizardStepIndex } from "../../hooks/useActiveWizardStepIndex";
import s from "./WizardStepper.module.css";

/**
 * Step definitions for the Pay Component Import wizard.
 * Four visible steps: Upload → Map Columns → Review → Results.
 * The "Validation Errors" screen is a sub-state of Results (no step of its own).
 */
const STEPS = [
  { label: "Upload", routes: ["", "/"] },
  { label: "Map Columns", routes: ["/map"] },
  { label: "Review", routes: ["/review"] },
  { label: "Results", routes: ["/results", "/errors"] },
] as const;

type StepStatus = "pending" | "active" | "completed";

/**
 * Read-only wizard step indicator used in `PayComponentImportLayout`.
 * Shows four steps (Upload → Map Columns → Review → Results) with the active
 * step derived from the current route.
 */
export function WizardStepper() {
  const activeIndex = useActiveWizardStepIndex();

  return (
    <nav aria-label="Import wizard progress">
      <ol className={s.stepper}>
        {STEPS.map((step, index) => {
          const status: StepStatus =
            index < activeIndex
              ? "completed"
              : index === activeIndex
                ? "active"
                : "pending";

          return (
            <li
              key={step.label}
              className={`${s.step} ${s[status]}`}
              aria-current={status === "active" ? "step" : undefined}
            >
              <span className={s.stepNumber} aria-hidden="true">
                {status === "completed" ? "✓" : `${index + 1}.`}
              </span>
              <span className={s.stepText}>{step.label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
